// import axios from 'axios'
// import {Message} from 'element-ui' // 项目用的element ui
// // import router from '../router'

// const service = axios.create({
//     timeout: 7000, // 超过7秒提示超时
//     baseUrl: 'https://www.baidu.com'
// })

// // 请求拦截器
// service.interceptors.request.use(
//     config => {
//         if(localStorage.token) {
//             config.headers.token = localStorage.token;
//         }
//         return config;
//     },
//     error => {
//         console.log(error);
//         return Promise.reject(error);
//     }
// )

// // 响应拦截器
// service.interceptors.response.use(
//     response => {
//         // 接收后台参数状态
//         const res = response.data;
//         if(res.code == 20000 || res.status == 200 || res.success || res.ErrorCode == 20000) {
//             return res;
//         }else {
//             let message = (res.error && res.error.message) || res.message || res.msg || '未知错误';
//             Message({
//                 message,
//                 type: 'error',
//                 duration: 5 * 1000
//             });
//             console.log('拦截器打印错误:', res);
//             // 这里可以设置后台返回状态码是500或者是其他,然后重定向跳转
//             // if(res.ErrorCode == 500) {
//             //     router.push('/login')
//             // }
//             return Promise.reject(
//                 new Error(res.message || (res.error &&res.error.message) || '未知错误')
//             );
//         }
//     },
//     error => {
//         console.log('服务器错误信息:', error);
//         if(error.response) {
//             // error.response有错误信息,是接口错误,不是取消请求
//             // 获取错误码,弹出提示信息,reject()
//             let code = error.response.status;
//             if(error.code == 401) {
//                 // router.push('/login');
//                 return Promise.reject(
//                     new Error('登录过期,请重新登录')
//                 );
//             }
//             Message({
//                 message: '服务器繁忙, 请稍后再试!  ' + code,
//                 type: 'error',
//                 duration: 3 * 1000
//             });
//             return Promise.reject(error.message);
//         }else {
//             // 是取消请求
//             // 直接reject
//             return Promise.reject(error.message);
//         }
//     }
// )
// export default service;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-urlencoded'
import axios from 'axios'
import router from '../router'

// var _this = this
const http = axios.create()
http.defaults.timeout = 1000 * 5
http.interceptors.request.use(config => { // 请求拦截器配置 // 可不配置
    // do sth
    if (localStorage.token) {
        config.headers.token = localStorage.token;
    }
    return config
}, error => {
    console.log(error)
    return Promise.reject(error)
})

http.interceptors.response.use(response => { // 响应拦截器配置 // 可不配置
    // do something
    if(router.currentRoute.path === '/login'){
        return response
    }else if (1001 === response.data.code) {
        alert('用户不存在')
        if (router.currentRoute.path !== '/login'){
            router.replace({
                path: '/login',
                query: { redirect: router.currentRoute.fullPath }
            })
        }
    }else if (1003 === response.data.code) {
        alert('用户未登录')
    } else if (1004 === response.data.code) {
        alert('登录已过期')
        router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
        })
    } else if (1005 === response.data.code) {
        alert('账号在别处登录')
        router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
        })
    } else if (1006 === response.data.code) {
        alert('非法访问')
        router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
        })
    } 
    return response
}, error => {
    console.log(error)
    return Promise.reject(error)
})


export function fetch(url, params) { // 封装axios的post请求
    return new Promise((resolve, reject) => { // promise 用法,自行查阅
        axios.post(url, params).then(response => {
            resolve(response.data) // promise相关
        }).catch(error => {
            reject(error) // promise相关
        })
    })
}

export default http

// export default { // 暴露htto_mock方法，即后面页面中用到的方法
//     http_mock(url, params) {
//         return fetch(url, params)
//     }
// }